var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useLayoutEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import AppWapper from "./AppWrapper";
import { ThemeContext } from "./contexts/theme-context";
import { useAppDispatch } from "./hooks/redux";
import { checkLogin, getGuestLoginCheck, } from "./apis/dashboard";
import { useLocation, useSearchParams } from "react-router-dom";
import CustomModalContainer from "./components/modal/custom-modal-container";
import useSystemThemeDetector from "./hooks/useSystemThemeDetector";
import { setOrderSummary } from "./redux/reducers/modals";
import { BODY_TAG, CHANNEL_BROADCAST, DATA_ATTRIBUTE_THEME, FNO_URL, THEME_DARK, THEME_LIGHT, USER_LOGOUT, } from "./utils/constant";
import { SESSION_KEYS, clearStorageAndSetTime, getDataFromSession, setDataInSession, } from "./utils/session-storage";
import moment from "moment";
import ExpandedRoutes from "./modals/common/ExpandedRoutes";
moment.locale("en-in");
const AddToWatchlist = React.lazy(() => import("src/modals/watchlist/add-to-watchlist"));
const BuySellForm = React.lazy(() => import("src/modals/common/BuySellForm"));
const CancelOrder = React.lazy(() => import("src/modals/common/CancelOrder"));
const PledgeUnpledge = React.lazy(() => import("src/modals/common/PledgeUnpledge"));
const SellAuth = React.lazy(() => import("src/modals/common/SellAuth"));
const CreateBasket = React.lazy(() => import("src/modals/common/CreateBasket"));
const BulkOrderForm = React.lazy(() => import("src/modals/common/BulkOrderForm"));
const AddToBasketWrapper = React.lazy(() => import("src/modals/common/AddToBasketWrapper"));
const SelectedExpiryOc = React.lazy(() => import("src/modals/common/SelectedExpiryOc"));
const App = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const themePassed = searchParams.get("theme");
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const dispatch = useAppDispatch();
    // const [expandWindow, setExpandWindow] = useState(false);
    // const [expandWindow, setExpandWindow] = useState(false);
    const currentURL = window.location.href;
    const isDarkTheme = useSystemThemeDetector();
    // const getCurrentTheme = (): string => {
    //   if (getDataFromSession(SESSION_KEYS.THEME) === "dark") return "dark";
    //   else if (getDataFromSession(SESSION_KEYS.THEME) === "light") return "light";
    //   else return isDarkTheme ? "dark" : "light";
    // };
    // const [theme, setTheme] = useState(getCurrentTheme());
    const [theme, setTheme] = useState(THEME_LIGHT);
    const titleMap = {
        "/open-interest": "F&O 360: Open Interest Chart for Nifty, Bank Nifty & More | 5paisa",
    };
    const descriptionMap = {
        "/open-interest": "Analyze open interest and view open interest charts for Nifty, Bank Nifty, Finnifty, Bankex, and Midcap Nifty with F&O 360 on 5paisa.",
    };
    const defaultTitle = "FnO 360: Advance Derivatives Trading Platform for Traders | 5paisa";
    const defaultDescription = "FnO 360: Explore advanced derivatives trading with customizable option chains, powerful orders, & user-friendly strategies on 5paisa's exclusive platform.";
    useLayoutEffect(() => {
        if (clientCode) {
            const loggedInTime = getDataFromSession(SESSION_KEYS.LOGIN_TIME);
            // Send message to all tabs that user is logged in
            if (loggedInTime) {
                const hours = Math.abs(Date.now() - loggedInTime) / 36e5;
                if (hours > 8) {
                    clearStorageAndSetTime();
                }
            }
            else {
                clearStorageAndSetTime();
            }
        }
    }, []);
    useEffect(() => {
        var _a;
        const currentPath = location.pathname;
        const matchedTitle = currentPath.startsWith("/open-interest")
            ? titleMap["/open-interest"]
            : defaultTitle;
        const matchedDescription = currentPath.startsWith("/open-interest")
            ? descriptionMap["/open-interest"]
            : defaultDescription;
        document.title = matchedTitle;
        (_a = document
            .querySelector("meta[name='description']")) === null || _a === void 0 ? void 0 : _a.setAttribute("content", matchedDescription);
    }, [location.pathname]);
    useEffect(() => {
        // Listen for logout event
        const channel = new BroadcastChannel(CHANNEL_BROADCAST);
        // Listen for logout event
        channel.onmessage = (event) => {
            if (event.data.event === USER_LOGOUT) {
                // User has logged out, redirect to login page
                setTimeout(() => {
                    clearStorageAndSetTime();
                }, 5000);
            }
        };
        //     // Listen for logout event
        return () => {
            channel.close();
        };
    }, []);
    //Change theme when we change system theme and selected theme is system-theme in FNO
    // useEffect(() => {
    //   if (getDataFromSession(SESSION_KEYS.THEME) === SYSTEM_THEME)
    //     setTheme(isDarkTheme ? "dark" : "light");
    // }, [isDarkTheme]);
    useEffect(() => {
        if (themePassed !== null) {
            if (currentURL.includes("oc-iframe"))
                setTheme(THEME_LIGHT);
            setDataInSession(SESSION_KEYS.THEME, THEME_LIGHT, true);
        }
        else if (getDataFromSession(SESSION_KEYS.THEME) === undefined)
            setDataInSession(SESSION_KEYS.THEME, THEME_LIGHT, true);
        setDataInSession(SESSION_KEYS.PREFERENCE_CHANGED, "false", true);
        // Taking reference of body element
        const bodyElement = document.getElementsByTagName(BODY_TAG)[0];
        //bodyElement.className = "dark";
        bodyElement.setAttribute(DATA_ATTRIBUTE_THEME, theme);
    }, [theme, isDarkTheme]);
    const toggleTheme = (selectedTheme) => {
        if (selectedTheme === THEME_LIGHT) {
            setTheme(THEME_LIGHT);
            setDataInSession(SESSION_KEYS.THEME, THEME_LIGHT, true);
            // Taking reference of body element
            const bodyElement = document.getElementsByTagName(BODY_TAG)[0];
            //bodyElement.className = "dark";
            bodyElement.setAttribute(DATA_ATTRIBUTE_THEME, THEME_LIGHT);
        }
        else if (selectedTheme === THEME_DARK) {
            setTheme(THEME_LIGHT);
            setDataInSession(SESSION_KEYS.THEME, THEME_LIGHT, true);
            // Taking reference of body element
            const bodyElement = document.getElementsByTagName(BODY_TAG)[0];
            // Changing the class of body Before mounting
            bodyElement.setAttribute(DATA_ATTRIBUTE_THEME, THEME_LIGHT);
        }
        else {
            setTheme(THEME_LIGHT);
            setDataInSession(SESSION_KEYS.THEME, THEME_LIGHT, true);
        }
    };
    const deleteCookie = (cookieName) => {
        if (document.cookie
            .split(";")
            .some((item) => item.trim().startsWith(`${cookieName}=`))) {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
            console.log(`Cookie ${cookieName} deleted.`);
        }
        else {
            console.log(`Cookie: ${cookieName} does not exist.`);
        }
    };
    function getBaseDomain() {
        const hostname = window.location.hostname;
        const parts = hostname.split(".");
        if (parts.length > 2) {
            return `.${parts.slice(-2).join(".")}`;
        }
        else if (parts.length === 2) {
            return `.${hostname}`;
        }
        else {
            throw new Error("Invalid hostname format");
        }
    }
    const getTokenForGuestLogin = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // const deleteCookieResponse =
            //   await delete5PaisaCookieCookieAndSetNewCookie();
            // if (deleteCookieResponse.data.status == 0) {
            //   {
            yield getGuestLoginCheck();
            //     if (response.status == 200) {
            //       // const response2 = await extractCookieFromHeader();
            //       // const cookie = response2.data.body["5paisacookie"];
            //       // setDataInSession(SESSION_KEYS.GUESTLOGIN_COOKIE, cookie, true);
            //     }
            //   }
            // }
        }
        catch (error) {
            console.error("Error:", error);
            return null;
        }
    });
    const checkUserLoggedIn = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield checkLogin();
            //const isLoggedIn = response?.data?.head["5paisacookie"] ? true : false;
            if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.head.status) == "0" &&
                response.data.body.Status == "0") {
                window.location.replace(FNO_URL);
            }
            else {
                yield getTokenForGuestLogin();
            }
        }
        catch (error) {
            console.error("check login failed", error);
            getTokenForGuestLogin();
        }
    });
    useEffect(() => {
        checkUserLoggedIn();
    }, []);
    if (process.env.REACT_APP_ENV === "production") {
        console.log = () => { };
        console.error = () => { };
        console.debug = () => { };
    }
    // if (!clientCode) {
    //   getTokenForGuestLogin();
    // } else {
    //   return <Login />;
    // }
    return (_jsx("div", { children: _jsx(ThemeContext.Provider, Object.assign({ value: { theme, toggleTheme } }, { children: _jsxs(React.Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: [_jsx(AppWapper, {}), _jsx(ExpandedRoutes, {}), _jsx(OutsideClickHandler, Object.assign({ onOutsideClick: () => {
                            dispatch(setOrderSummary(false));
                        } }, { children: _jsx(CustomModalContainer, {}) })), _jsx(BuySellForm, {}), _jsx(CancelOrder, {}), _jsx(PledgeUnpledge, {}), _jsx(SellAuth, {}), _jsx(AddToWatchlist, {}), _jsx(CreateBasket, {}), _jsx(BulkOrderForm, {}), _jsx(AddToBasketWrapper, {}), _jsx(SelectedExpiryOc, {})] })) })) }));
};
export default App;
